import { FilterValue, PillFilters } from 'features/common-elements';
import { searchQueryToFilterValues, filterValuesToSearchQuery } from 'features/common-elements';
import {
  MarketplaceFiltersConfig,
  useMarketplaceFiltersConfig,
  abbrToFilterKey,
  filterKeyToAbbr,
  ListingKey,
} from 'features/OnMarket/marketplace.config';
import { ListingType, MarketplaceTable } from 'features/OnMarket/MarketplaceTable';
import { useSearchParams } from 'react-router-dom';

import * as navigation from '../../../app-level/navigation';

// `listings` used to come from the now-removed `listings` query (api#944); this
// page has no data source left to fetch it from, so it renders an empty table
// until ENG-3856's sales index/blotter replaces this page for real.
const EMPTY_LISTINGS: ListingType[] = [];

const MarketHome = () => {
  const [search, setSearch] = useSearchParams();
  const searchFiltersStr = search.get('filters');
  const currentFilters = searchFiltersStr
    ? searchQueryToFilterValues(searchFiltersStr, abbrToFilterKey)
    : [];

  const marketplaceFiltersConfig = useMarketplaceFiltersConfig();

  const [marketHomeSorting, setMarketHomeSortingSorting] =
    navigation.useSortingHelper<ListingKey>();

  function setFilters(filters: FilterValue<MarketplaceFiltersConfig>[]) {
    const newFilters = filterValuesToSearchQuery(filters, filterKeyToAbbr);
    const newSearch = new URLSearchParams();
    newSearch.set('filters', newFilters);
    setSearch(newSearch);
  }

  return (
    <>
      <div className="p-3" style={{ gridArea: 'summery' }}>
        <PillFilters
          filtersConfig={marketplaceFiltersConfig}
          currentFilters={currentFilters}
          setCurrentFilters={setFilters}
        />
      </div>
      <div className="min-w-[14px]" style={{ gridArea: 'sidebar' }}></div>
      <div className="page">
        <MarketplaceTable
          data={EMPTY_LISTINGS}
          sorting={{
            state: marketHomeSorting,
            onSortingChanged: setMarketHomeSortingSorting,
          }}
        />
      </div>
    </>
  );
};

export default MarketHome;
